import { defineStore } from 'pinia';

export const useSubNavigationStore = defineStore('subNav', {
	state: () => ({
		visibilityOptions: [
			{ id: 'kw', name: 'ActivSEO' },
			{ id: 'ai', name: 'ActivGEO' },
		],
	        aiTypeOptionsDashboard: [
	            { id: 'global', name: 'Global' },
				{ id: 'ai_mode', name: 'Ai Mode' },
				{ id: 'chatgpt', name: 'ChatGPT' },
				{ id: 'perplexity', name: 'Perplexity' },
				{ id: 'ai_overview', name: 'Ai Overview' },
			],
	        aiTypeOptionsVisibility: [
			{ id: 'chatgpt', name: 'ChatGPT' },
			{ id: 'ai_mode', name: 'Ai Mode' },
			{ id: 'perplexity', name: 'Perplexity' },
			{ id: 'ai_overview', name: 'Ai Overview' },
		],
		selectedVisibility: 'kw',
		selectedAiTypeDashboard: 'global',
		selectedAiTypeVisibility: 'chatgpt',
	}),
	persist: true,
});
